export default {
    tourSteps: [
        {
            target: '#btnBlankDeck',  // We're using document.querySelector() under the hood
            content: `Welcome to quizMe.<br/><br/>  To get started, add a new deck of cards by clicking <strong>Add  Deck</strong>`,
            params: { placement: 'top' }
        },
        {
            target: '#anotherStep',
            content: `a`
        }
    ],
    tourDeckEdit: [
        {
            target: '#txtDeckTitle',
            content: `You can give your deck a title based on what you want to learn`,
            params: { placement: 'left' }
        },
        {
            target: '#cardListHeading',
            content: `Decks contain cards.<br/>  In this new deck, you already have one card ready to go`,
            params: { placement: 'top' }
        },
        {
            target: '#question_prompt',
            content: `Add a question or prompt.`
        },
        {
            target: '#answer_prompt',
            content: `Then add the answer or what you want to remember.`
        },
        {
            target: '#btnSaveDeck',
            content: `Your deck is saved automatically, but you can also save anytime by clicking <strong>Save</strong>`
        },
        {
            target: '#btnLearnDeck',
            content: `Now you're reading to start learning!  Click <strong>Learn</strong>`
        }
    ],
    tourDeckLearn: [
        {
            target: '#txtSelectedCardQ',
            content: `Here you'll see the question or prompt you created for this card`,
            params: { placement: 'left' }
        },
        {
            target: '#btnShowAnswer',
            content: `Click <strong>Answer</strong> to see the answer`
        },
        {
            target: '#txtSelectedCardA',
            content: `You'll see the answer displayed here`,
            params: { placement: 'left' }
        },
        {
            target: '#cardAnswerCard',
            content: `How well did you know it?  Once you click one of these you'll be shown the next card. <br/>  We'll automatically remind you when it is time to review this card again.`
        },
        {
            target: '#lblLearningHeader',
            content: `You can go back to the deck, or see all your decks by going Home.<br/><br/> It's that easy...happy learning!`,
            params: { placement: 'left' }
        }
    ]
}